import { render, staticRenderFns } from "./TreesTen.vue?vue&type=template&id=0a969c9f&scoped=true"
var script = {}
import style0 from "./TreesTen.vue?vue&type=style&index=0&id=0a969c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a969c9f",
  null
  
)

export default component.exports